import { ISite } from '@metservicedev/platforms-services-interface/src/services/movSites/MovSitesV2Model';
import produce from 'immer';

import { ReportSiteAction, SetTimeAction, TemplateLoadedAction, TypeKeys } from '../../state-management/widgetblock/actions/types';
import { HeaderConfigBlockState, HeaderState } from './types';

type Actions = SetTimeAction | ReportSiteAction<ISite> | TemplateLoadedAction<HeaderConfigBlockState>;

const INITIAL_STATE: HeaderState = {
    viewblockState: null,
};

const reducer = produce((draft, action: Actions) => {
    switch (action.type) {
        case TypeKeys.SET_TIME:
            draft.time = { iso8601: action.payload.iso8601, timezone: action.payload.timezone };

            break;

        case TypeKeys.TEMPLATE_LOADED:
            draft.viewblockState = action.payload.data;

            break;

        case TypeKeys.SET_REPORT_SITE:
            draft.site = action.payload.site;

            break;
    }

    if (draft.viewblockState?.settings) {
        const {
            time,
            site,
            viewblockState: { settings },
        } = draft;

        draft.model = { settings, time, site: settings.site || site };
    }
}, INITIAL_STATE);

export default reducer;
